import { VNode, h } from "preact";
import { InputLine } from "./InputLine.js";
import { UIFormProps } from "../FormProvider.js";

export function InputSecret(
  props: UIFormProps<string>,
): VNode {
  return <InputLine type="password" {...props} />;
}
